import type { KambiEvent } from '@mobi/api-types/kambi'

export function getEventDetailsFromEvent(event: KambiEvent): {
  eventName: string
  shouldSwitchHomeAway: boolean
  leftTeam: TeamData
  rightTeam: TeamData
} {
  const shouldSwitchHomeAway = !!event.awayName && event.nameDelimiter === '@'
  const participants = event.participants ?? []

  const homeTeam = {
    name: event.homeName,
    participantId: participants.find(p => p.home === true)?.participantId ?? null,
  }
  const awayTeam = {
    name: event.awayName || '',
    participantId: participants.find(p => p.home === false)?.participantId ?? null,
  }

  if (shouldSwitchHomeAway) {
    return { eventName: event.name, leftTeam: awayTeam, rightTeam: homeTeam, shouldSwitchHomeAway }
  }

  const leftTeam = homeTeam
  const rightTeam = awayTeam

  return {
    eventName: `${leftTeam.name} v ${rightTeam.name}`,
    leftTeam,
    rightTeam,
    shouldSwitchHomeAway,
  }
}

// =====
// Types
// =====

type TeamData = {
  name: string
  participantId: number | null
}
